
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { defaultLabeledREs, TLabeledRE, TPasswordRequirement } from "./DPasswordRequirements";

const ICONS = {
  checkmark: "checkmark-outline",
  close: "close-outline",
};

@Component
export default class PasswordRequirements extends Vue {
  @Prop({ type: String, required: true }) readonly text!: string;
  @Prop({ type: Array, default: () => defaultLabeledREs }) readonly labeledREs!: TLabeledRE[];

  icons = ICONS;

  state = {
    isActive: false,
  };

  @Watch("text")
  textChanged() {
    const isTextFilled = this.text.length > 0;

    this.state.isActive = isTextFilled;
  }

  get requirements(): TPasswordRequirement[] {
    const { text, labeledREs, state } = this;

    return labeledREs
      .map(({ label, re }) => ({
        label,
        isMet: re.test(text),
      }))
      .map(({ label, isMet }) => ({
        classes: {
          item_success: isMet,
          item_error: !isMet,
        },
        label,
        isMet,
      }));
  }

  getIconName(isMet: boolean) {
    return isMet ? this.icons.checkmark : this.icons.close;
  }
}
